import React, { useState } from "react";
import { Col, Form, Input, Row, Button, Radio, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../../redux/alertsSlice";
import Layout from "../../components/layout";

function StaffRegister() {
const [role, setRole] = useState("staff"); 

 const onChange = (e) => {
    setRole(e.target.value);
 };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      dispatch(showLoading());
      const isStaff    = role === "staff";
      const regDoctor  = role === "doctor";
       const isAdmin    = role === "admin";
                 // all internal users are pre‑verified

      const response = await axios.post("/api/admin/register", {
        ...values,
        role: values.toString(),
        
        isStaff,
        isAdmin,
        regDoctor,
      });
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  return (
    <Layout>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Card title="Staff Registration" bordered>
          <Form layout="vertical" className="formFactor" onFinish={onFinish}>
            <Row gutter={20}>
              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  required
                  name="name"
                  label="Full Name"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  required
                  name="email"
                  label="Email Address"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Email Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  required
                  name="phone"
                  label="Phone Number"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Phone Number" />
                </Form.Item>
              </Col>

              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  name="password"
                  label="Passcode"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password placeholder="Passcode" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col span={12} xs={24} sm={24} lg={12}>
                <Form.Item
                  required
                  label="User Role"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={onChange} value={role}>
                    <Radio value="staff">Staff</Radio>
                    <Radio value="doctor">Doctor</Radio>
                   <Radio value="admin">Admin</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            <div className="d-flex justify-content-end">
              <Button type="primary"   className="btn-primary" htmlType="submit">
                CREATE
              </Button>
            </div>
          </Form>
        </Card>
      </div>
    </Layout>
  );
}

export default StaffRegister;
